/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import { getPredictCost } from '@pt/api/user'
import { MaybeRef } from '@types-vue/shared'
import { MainPlan } from '@ve-pro/enums/plan'
import {
  // defineComponent,
  // onMounted,
  unref,
  ref,
  UnwrapRef,
  // watch,
  // computed,
  // nextTick,
} from 'vue'
import axios, { CancelTokenSource } from 'axios'

/**
 * 支付方式
 */
export enum usageType {
  money = 'money',
  online = 'online',
  storage = 'storage',
  download_push = 'download_push',
  video_credits = 'video_credits',
}

interface PostData {
  biz_type: MainPlan
  durations?: number[] // 接口使用毫秒
  num?: number // 次数
  usage_type?: usageType
}

export interface queryParams {
  biz_type: MainPlan
  costNum: number | number[]
  costType: keyof Pick<Required<PostData>, 'durations' | 'num'>
  usage_type?: usageType
}

export function usePlanMarginChecking(params: MaybeRef<queryParams>) {
  const result = ref({
    balance: 0,
    cost: 0,
    enable: false,
    update: (data?: UnwrapRef<typeof params>) => {
      const updateData = data || unref(params)
      return update(updateData)
    },
  })

  let source: CancelTokenSource | null = null

  function update(data: UnwrapRef<typeof params>) {
    if (source) {
      source.cancel()
    }

    source = axios.CancelToken.source()

    const postData: PostData = {
      biz_type: data.biz_type,
      usage_type: data.usage_type,
    }
    if (data.costType === 'durations') {
      postData[data.costType] =
        typeof data.costNum === 'number' ? [data.costNum] : data.costNum
    }
    if (data.costType === 'num') {
      postData[data.costType] = data.costNum as number
    }
    return getPredictCost(postData, {
      cancelToken: source.token,
    })
      .then((res) => {
        if (res.data.code === 0) {
          const cost = res.data.data.costs.reduce(
            (total, cur) => total + cur,
            0,
          )
          result.value.cost =
            res.data.data.usage_type === usageType.money ? cost / 100 : cost
          result.value.balance =
            res.data.data.usage_type === usageType.money
              ? res.data.data.balance / 100
              : res.data.data.balance
          result.value.enable =
            result.value.balance > 0 && result.value.cost < result.value.balance
        }
      })
      .finally(() => {
        source = null
      })
  }

  // onMounted(() => {
  //   update(unref(params))
  // })

  // watch(
  //   () => unref(params),
  //   (_data) => {
  //     const data = unref(_data)
  //     update(data)
  //   },
  //   {
  //     deep: true,
  //   },
  // )

  return result
}
